import React from "react";
import "./index.css";
import { ThreeCircles } from "react-loader-spinner";
import { useTheme } from "@mui/material";

const Loading = () => {
  const theme = useTheme();
  const location = window.location.pathname;
  const isAdminPath = location.includes("/admin");
  return (
    <div
      className="react-loader"
      style={{
        background: isAdminPath
          ? theme.palette.background.adminBg
          : "inherit",
      }}
    >
      <ThreeCircles
        height="80"
        width="80"
        color={"var(--accent-clr2)"}
        ariaLabel="grid-loading"
        wrapperClass=""
        visible
      />
      <h1 className="react-loader-text" style={{ background: "transparent" }}>
        Loading...
      </h1>
    </div>
  );
};

export default Loading;
